import {
  FETCH_STORE,
  FETCH_STORE_SUCCESS,
  FETCH_STORE_FAILED
} from '../../types';

const initialState = {
  store: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchStoreReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_STORE:
      return {
        ...state,
        isLoading: true,
          store: action.payload
      }
      case FETCH_STORE_SUCCESS:
        return {
          ...state,
          isLoading: false,
            store: action.payload
        }
        case FETCH_STORE_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchStoreReducer;
